import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=44696e1e"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=44696e1e&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44696e1e')) {
      api.createRecord('44696e1e', component.options)
    } else {
      api.reload('44696e1e', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=44696e1e", function () {
      api.rerender('44696e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Comments.vue"
export default component.exports